import Select from './components/select'

import HomeView from './views/home-view'

import jQuery from 'jquery'

window.$ = window.jQuery = jQuery

window.HomeView = HomeView

import cookies from 'browser-cookies'
import Switch from 'weatherstar-switch'

// handle dark theme
$(() => {
	Select.declarative()

	new Switch($('.dark-theme')[0], {
		size: 'small',
		onSwitchColor: '#f27e02',
		onChange: () => {
			if ($('.dark-theme').is(':checked')) {
				$('html').addClass('dark')
				$('.screenshot').each((index, el) => { $(el).attr('src', $(el).data('src-dark')) })
				cookies.set('theme', 'dark', { expires: 365 })
		 	} else {
				$('html').removeClass('dark')
				$('.screenshot').each((index, el) => { $(el).attr('src', $(el).data('src-light')) })
				cookies.erase('theme')
			}
		}
	})
})

import Vue from 'vue'

import Changelog from './components/changelog'
import Changelogs from './components/changelogs'
import FixedNav from './components/fixed-nav'

Vue.component('changelogs', Changelogs)
Vue.component('changelog', Changelog)
Vue.component('fixed-nav', FixedNav)

import './directives/highlight-on-element'

const app = new Vue({
	el: '#app'
})
